import { api } from './client.js';

export const workspaceApi = {
  show: (id) => api.get(`/workspaces/${id}`).then((r) => r.data),
  update: (id, payload) => api.patch(`/workspaces/${id}`, payload).then((r) => r.data),
};

export const aiApi = {
  generatePage: (pageId, prompt) =>
    api.post('/ai/generate-page', { page_id: pageId, prompt }).then((r) => r.data),
  rewrite: (workspaceId, text, tone) =>
    api
      .post('/ai/rewrite', { workspace_id: workspaceId, text, tone })
      .then((r) => r.data.text),
};
